import { CAnalyticsGateway } from "@configured/adapters/CAnalyticsGateway";
import { GetUserInfoInteractor } from "@use-cases/GetUserInfoInteractor";
import { CNotehubAuth } from "../adapters/CNotehubAuth";

export const CGetUserInfoInteractor = new GetUserInfoInteractor({
  authority: CNotehubAuth,
  analyticsGateway: CAnalyticsGateway,
});
